import { useLogin } from "../hooks/useLogin"
import { Button, Form, Input, Row, Col, Checkbox, Typography, message } from "antd"
import { LockOutlined, UserOutlined } from "@ant-design/icons"
import logo from "../media/images/craftika-cms-logo.svg"
import "./css/Login.css"

const { Title, Text } = Typography

export default function Login() {
  const { login } = useLogin()
  const [form] = Form.useForm()

  const onFinish = (values) => {
    login(values.username, values.password)
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  return (
    <div className="login-container">
      <Row align="middle" justify="center" style={{ minHeight: "100vh" }}>
        <Col xs={22} sm={20} md={12} lg={8} xl={7}>
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "48px 32px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            }}>
            {/* Logo */}
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <img
                src={logo}
                alt="Craftika CMS"
                style={{ height: "120px", marginBottom: "24px" }}
              />
            </div>

            {/* Form */}
            <Form
              form={form}
              name="login"
              layout="vertical"
              size="large"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{ marginTop: "32px" }}>
              <Form.Item
                name="username"
                label={
                  <span style={{ fontWeight: "500", marginBottom: "2px", display: "block" }}>
                    Username
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter your username",
                  },
                ]}
                style={{ marginBottom: "16px" }}>
                <Input
                  prefix={<UserOutlined style={{ color: "#999" }} />}
                  placeholder="example@example.com"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #d9d9d9",
                    height: "40px",
                  }}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={
                  <span style={{ fontWeight: "500", marginBottom: "2px", display: "block" }}>
                    Password
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter your password",
                  },
                ]}
                style={{ marginBottom: "16px" }}>
                <Input.Password
                  prefix={<LockOutlined style={{ color: "#999" }} />}
                  placeholder="your password"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #d9d9d9",
                    height: "40px",
                  }}
                />
              </Form.Item>

              <Form.Item name="remember" valuePropName="checked" style={{ marginBottom: "24px" }}>
                <Checkbox style={{ color: "#666" }}>Remember me</Checkbox>
              </Form.Item>

              <Form.Item style={{ marginBottom: "0" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(22, 119, 255, 1) 35%, rgba(47, 84, 235, 1) 100%)",
                    border: "none",
                    height: "42px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "6px",
                  }}>
                  Login
                </Button>
              </Form.Item>
            </Form>

            {/* Footer */}
            <div
              style={{
                textAlign: "center",
                marginTop: "24px",
                color: "#999",
                fontSize: "12px",
              }}>
              <Text type="secondary">© 2026 Craftika CMS. All rights reserved.</Text>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
